<template>
    <div class="modal fade" id="flyOutModal" tabindex="-1" aria-labelledby="flyOutModalLabel" aria-hidden="true">
        <div class="modal-dialog fadeInRight animated">
            <div class="modal-content">
                <div class="row no-gutters">
                    <div class="col-6 d-none d-lg-block">
                        <img class="img-fluid h-100" :src="formConfig.image" :alt="formConfig.alt">

                    </div>
                    <div class="col-lg-6">
                        <div class="modal-header">
                            <button type="button" class="close border-0" data-dismiss="modal" aria-label="Close">
                                <img src="/img/site/icons/close-bl.svg" alt="Close">
                            </button>
                            <h3 class="modal-title text-primary text-uppercase" id="flyOutModalLabel">
                                {{ panel.title }}
                            </h3>
                        </div>
                        <div class="modal-body">
                            <p v-if="message" class="alert alert-success" v-html="message"></p>
                            <p v-else-if="error" class="alert alert-danger" v-html="error"></p>
                            <div v-else v-html="panel.content"></div>
                            <form-component
                                :initialData="formData"
                                :config="formConfig"
                                :loading="loading"
                                v-on:input="handleFormInput"
                                v-on:error="handleFormError"
                                ></form-component>
                            <!-- <form action=""> -->
                            <!--     <div class="form-group"> -->
                            <!--         <input type="text" class="form-control" placeholder="First name*"> -->
                            <!--     </div> -->
                            <!--     <div class="form-group"> -->
                            <!--         <input type="text" class="form-control" placeholder="Company name*"> -->
                            <!--     </div> -->
                            <!--     <div class="form-group"> -->
                            <!--         <input type="text" class="form-control" placeholder="Your email*"> -->
                            <!--     </div> -->
                            <!--     <div class="form-group"> -->
                            <!--         <select class="selectpicker" data-style="btn-select" data-width="100%" name="" id=""> -->
                            <!--             <option value="">Which of the following best describes you?</option> -->
                            <!--             <option value="">I run a construction business. We don't currently build with Cold Formed Steel</option> -->
                            <!--             <option value="">I run a construction business. We have some experience of Cold Formed Steel.</option> -->
                            <!--             <option value="">I run a modular construction or building business currently using steel as part of the mix.</option> -->
                            <!--             <option value="">I run a steel fabrication suppliers. We want to take advantage of increasing demand for Cold Formed Steel.</option> -->
                            <!--             <option value="">I'm a consultant, engineer or architect looking for information on modular steel construction methods.</option> -->
                            <!--             <option value="">I'm a senior executive at a corporate developer looking at modular steel construction solutions.</option> -->
                            <!--             <option value="">I run an interior contractor business installing commercial interiors, dry lining interior partitioning etc.</option> -->
                            <!--             <option value="">I'm a student researching modular and cold formed steel construction processes.</option> -->
                            <!--             <option value="">I'm interested in employment opportunities or representing Howick in an overseas territory.</option> -->
                            <!--             <option value="">I'm a competitor looking for insights into Howick's innovative technology and processes.</option> -->
                            <!--         </select> -->
                            <!--     </div> -->
                            <!--     <button type="button" class="btn btn-yellow d-block w-100 text-center">Download your free guide</button> -->
                            <!-- </form> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import M from 'moment';
import UtilsMixin from './UtilsMixin';
import FormComponent from './form/FormComponent';

export default {
    data() {
        return {
            search: null,
            message: null,
            error: null,
            loading: false,
            formData: {},
        }
    },

    created() {
        if (window.localStorage.getItem('resource-form-data')) {
            try {
                this.formData = JSON.parse(window.localStorage.getItem('resource-form-data'));
            } catch (err) {
                this.formData = {};
            }
        }

        this.formData.filename = _.get(this.panel, 'file.name');
    },

    mounted() {
        setTimeout(() => {
            $('#flyOutModal').modal('show');
        }, 10000)
    },

    props: ['initialData', 'config'],

    components: {
        FormComponent,
    },

    mixins: [UtilsMixin],

    watch: {

    },

    computed: {
        panel() {
            return _.get(this.config, 'panel');
        },

        currentFile() {
            return _.get(this.panel, 'file');
        },

        formConfig() {
            return _.chain(this.config)
                .get('form')
                .set('btnLabel', this.$t('site.form-download-freeguide'))
                .set('btnClass', 'w-100 text-center')
                .set('showMessage', false)
                .value();
        },
    },

    methods: {
        handleFormInput(res) {
            this.loading = true;
            window.localStorage.setItem('resource-form-data', JSON.stringify(res.data));

            return this.api.postData('/downloads', {}, {
                token_id: res.id,
                file: _.get(this.currentFile, 'id'),
            }).then((res) => {
                this.message = this.$t('site.form-download-success');

                let downloadLink = _.filePath(this.currentFile, true);
                window.open(downloadLink, '_self');
            }).finally(() => {
                this.loading = false;
            })
        },

        handleFormError(err) {
            let res = _.get(err, 'response.data');
            let errors = _.chain(res).get('errors', [])
                .values()
                .flatMap(v => `<li>${v}</li>`)
                .join()
                .value();

            if (res) {
                this.error = `
                    <p>${res.message}</p>
                    <ul>${errors}</ul>
                `;
            } else {
                this.error = this.$t('site.form-download-error');
            }
        },
    }
}
</script>